import { schema } from "normalizr";

export const defaultRoundSettings = new schema.Entity("defaultRoundSettings");
